import { ArrayOps } from '../lift';
/**
 * Creates an array without any duplicate item.
 * If a key function is passed, items will be compared based on the result of that function;
 * if not, they will be compared using strict equality.
 */
export function distinct(getKey) {
    var arr = this.value(), result = [];
    var keySet;
    var refList;
    if (getKey)
        keySet = {};
    else
        refList = [];
    for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (getKey) {
            var key = getKey(item, i);
            if (!keySet[key]) {
                keySet[key] = 1;
                result.push(item);
            }
        }
        else {
            if (refList.indexOf(item) === -1) {
                refList.push(item);
                result.push(item);
            }
        }
    }
    return new ArrayOps(result);
}
ArrayOps.prototype.distinct = distinct;
